import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Disclaimer from 'components/Disclaimer';
import Error from 'components/Error';
import Informations from 'components/Informations';
import Navigation from 'components/Navigation';
import { translate } from 'helpers/Translate';

const Form = ({
    children,
    stepConfiguration,
    stepState,
    sidePanel,
    clickNext,
    clickPrevious,
    submit,
    error,
    onErrorDiscard,
    values,
    pending,
}) => {
    const titleClasses = classnames({
        'text--h2': true,
        'step-title': true,
        'step-title--subtitle': stepConfiguration.descriptionText,
    });

    const subTitle =
        typeof stepConfiguration.subtitle === 'function'
            ? stepConfiguration.subtitle(values || {})
            : stepConfiguration.subtitle;

    return (
        <form noValidate className="estima__wrapper" data-form-wrapper>
            <div className="left-backdrop" />
            <div className="right-backdrop" />
            <Error error={error} discard={onErrorDiscard} />
            <div className="estima__container centered-content">
                <div className="estima__container-left">
                    <div className="form-wrapper">
                        {subTitle && (
                            <h2 className={titleClasses}>
                                <span className={stepConfiguration.optional ? 'margin-right' : ''}>
                                    {subTitle}
                                </span>
                                {stepConfiguration.optional && (
                                    <span className="optional--label">
                                        ({translate('facultatif')})
                                    </span>
                                )}
                            </h2>
                        )}
                        {children}
                    </div>
                    {!stepConfiguration.hideNavigation && (
                        <Navigation
                            stepState={stepState}
                            clickNext={clickNext}
                            clickPrevious={clickPrevious}
                            submit={submit}
                            pending={pending}
                            lastStepLabel={translate('Voir mon estimation')}
                        />
                    )}
                </div>
                <div className="estima__container-right">
                    {sidePanel ||
                        (stepConfiguration.informations && (
                            <Informations
                                content={stepConfiguration.informations}
                                iconInformation={stepConfiguration.iconInformation}
                                disclaimer={stepConfiguration.disclaimer}
                            />
                        ))}
                    {stepConfiguration.disclaimer && <Disclaimer spaced />}
                </div>
            </div>
        </form>
    );
};

Form.displayName = 'Form';

Form.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    clickNext: PropTypes.func,
    clickPrevious: PropTypes.func,
    sidePanel: PropTypes.node,
    stepConfiguration: PropTypes.shape({}).isRequired,
    stepState: PropTypes.shape({}).isRequired,
};

/**
 * Form Functional Component.
 */
export default Form;
